module.exports = "https://preprod.web-phone.apps.phone.com/static/media/ring-sound.ad47ec32.mp3";